import { Box, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import Image from "next/image";
import * as React from "react";

type Props = {
  blog: any;
};

export default function BlogCard({ blog }: Props): React.ReactElement {
  const date = React.useMemo(
    () => format(parseISO(blog.date), "MMMM do, yyyy"),
    [blog.date]
  );

  return (
    <Box
      sx={{
        cursor: "pointer",
        "&:hover": {
          "& .blog-title": {
            textDecoration: "underline",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: 180,
        }}
      >
        <Image
          src={blog.coverImage + "?w=800"}
          alt={blog.title.toLocaleLowerCase()}
          layout="fill"
          objectFit="cover"
          unoptimized={true}
        />
      </Box>
      <Typography
        variant="subtitle1"
        component="div"
        className="blog-title"
        sx={{
          mt: 1,
          textDecoration: "inherit",
        }}
      >
        {blog.title}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        component="div"
        sx={{
          mt: 0.5,
          fontSize: (theme) => theme.typography.caption.fontSize,
          textDecoration: "none",
          "&:hover": {
            textDecoration: "none",
          },
        }}
      >
        {date}
      </Typography>
      <Box
        component="button"
        sx={{
          mt: 1,
          border: "0px",
          bgcolor: "transparent",
          p: 0,
          cursor: "pointer",
          "&:hover": {
            color: (theme) => theme.palette.primary.main,
          },
        }}
      >
        Read More »
      </Box>
    </Box>
  );
}
